// api.js
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,           // All your FastAPI routes start with /api
  withCredentials: true,     // Important because you use HttpOnly cookies!
});

// Global response interceptor
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response && error.response.status === 401) {
      handleUnauthorized();
    }
    return Promise.reject(error);
  }
);

function handleUnauthorized() {
  console.log("⛔ 401 Unauthorized detected — logging out");

  // Clear anything you store (match your real token key)
  localStorage.removeItem('access_token');
  sessionStorage.clear();

  // Redirect to login page
  window.location.href = '/login';
}

export default api;
